import { IClassListItem } from "../../../model/respone/classes/IClassListItem";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eClassesActionTypeDefine = {
    LOAD_START: undefined as undefined,
    LOAD_SUCCESS: [] as IClassListItem[],
    LOAD_ERROR: "" as string,
    /** Bulk update slot từ /api/registration/slots — refresh khi chọn môn / click Tải lại. */
    UPDATE_SLOTS: {} as Record<number, number>,
};

export const eClassesActionTypeIds = generateActionTypeIds(eClassesActionTypeDefine, "CLASSES");

export type IClassesActions = IGenericActionType<typeof eClassesActionTypeDefine, "CLASSES">;
